import { Injectable } from '@angular/core';
import { DataType, ExtensionCommunicationService } from '@shared/extension';
import { StoreName } from '../enums';
import { AntipatternData, AntipatternState } from '../interfaces';
import { AbstractStore } from './abstract';

@Injectable()
export class AntipatternStore extends AbstractStore<AntipatternState> {
  // Main selectors
  readonly antipatternData$ = this.select('antipatternData');

  constructor(protected extensionCommunicationService: ExtensionCommunicationService) {
    super(extensionCommunicationService, StoreName.AntipatternStore, {
      antipatternData: [null, DataType.Object],
    });
  }

  async setAntipatternData(data: AntipatternData | null): Promise<void> {
    await this.setValue('antipatternData', data);
  }
}
